/**
 * Dev-only diagnostics for site-switch / statistics refresh investigation.
 * Enable with NODE_ENV=development or REACT_APP_SITE_STATS_DEBUG=true
 */
const enabled =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_SITE_STATS_DEBUG === 'true';

export function siteStatsDebug(tag, payload) {
  if (!enabled) return;
  const msg = typeof payload === 'string' ? payload : JSON.stringify(payload);
  console.log(`[${tag}] ${msg}`);
}

export function isSiteStatsDebugEnabled() {
  return enabled;
}

/** Decode impersonateConfigId from JWT payload (client-side, dev only). */
export function decodeJwtImpersonateConfigId(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    const id = payload.impersonateConfigId;
    if (id == null) return null;
    const n = parseInt(id, 10);
    return Number.isNaN(n) ? null : n;
  } catch {
    return null;
  }
}
